<section class="stats">
  <header class="stats__header">
    <button type="button" class="stats__toggle" (click)="toggle()" [attr.aria-expanded]="open">
      <i class="pi" [ngClass]="open ? 'pi-chevron-down' : 'pi-chevron-right'" aria-hidden="true"></i>
      <span class="stats__title">{{ 'log.channels.stats.title' | transloco }}</span>
    </button>
    <span class="stats__summary" *ngIf="response">
      <span>{{ 'log.channels.stats.period' | transloco }} <b class="stats__num">{{ durationSeconds }} s</b></span>
      <span>
        {{ 'log.channels.stats.rows' | transloco }}
        <b class="stats__num">{{ response.rows_analyzed }}</b> / <span class="stats__num">{{ response.rows_file }}</span>
      </span>
    </span>
    <i class="pi pi-spin pi-spinner stats__spinner" *ngIf="loading" [attr.aria-label]="'log.channels.stats.loading' | transloco"></i>
  </header>

  <div class="stats__body" *ngIf="open">
    <!-- Erro não esconde o gráfico: fica só dentro desta seção -->
    <div class="stats__state stats__state--error" *ngIf="error" role="alert">
      <span>{{ 'log.channels.stats.error' | transloco }} <span class="stats__error-detail">{{ error.message }}</span></span>
      <button type="button" class="stats__retry" (click)="retry()">{{ 'log.channels.stats.retry' | transloco }}</button>
    </div>

    <p class="stats__state" *ngIf="!error && !loading && !response && channels.length === 0">
      {{ 'log.channels.stats.empty' | transloco }}
    </p>

    <div class="stats__scroll" *ngIf="rows.length" [class.stats__scroll--stale]="loading">
      <table class="stats__table">
        <thead>
          <tr>
            <th scope="col" class="stats__th stats__th--name">{{ 'log.channels.stats.col.channel' | transloco }}</th>
            <th scope="col" class="stats__th">{{ 'log.channels.stats.col.unit' | transloco }}</th>
            <th scope="col" class="stats__th stats__th--num" *ngFor="let col of columns">
              {{ 'log.channels.stats.col.' + col | transloco }}
            </th>
            <th scope="col" class="stats__th stats__th--num" [title]="'log.channels.stats.col.counts_hint' | transloco">
              {{ 'log.channels.stats.col.counts' | transloco }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr class="stats__row" *ngFor="let row of rows; trackBy: trackRow" [class.stats__row--missing]="row.state === 'missing'">
            <td class="stats__td">
              <span class="stats__name">
                <span class="stats__dot" [style.background]="row.color"></span>
                <span class="stats__label">{{ row.label }}</span>
              </span>
            </td>

            <!-- Canal ausente no log: não é zero nem nulo -->
            <td class="stats__td stats__td--missing" *ngIf="row.state === 'missing'" [attr.colspan]="columns.length + 2">
              {{ 'log.channels.stats.missing' | transloco }}
            </td>

            <ng-container *ngIf="row.state === 'stats' && row.stats as s">
              <td class="stats__td">
                <span class="stats__unit" [class.stats__unit--unknown]="row.unit === null">
                  {{ row.unit ?? ('log.channels.units.unknown' | transloco) }}
                </span>
                <span
                  class="stats__badge"
                  *ngIf="row.projected"
                  [pTooltip]="'log.channels.stats.projected_hint' | transloco"
                  tooltipPosition="top"
                  >{{ 'log.channels.stats.projected' | transloco }}</span
                >
              </td>
              <td class="stats__td stats__td--num" *ngFor="let col of columns" [attr.data-state]="cellState(s[col])" [attr.data-col]="col">
                {{ cell(s[col]) }}
              </td>
              <td class="stats__td stats__td--num stats__td--counts">
                <span [title]="'log.channels.stats.valid' | transloco">{{ s.valid_count }}</span> ·
                <span [title]="'log.channels.stats.null' | transloco">{{ s.null_count }}</span> ·
                <span [title]="'log.channels.stats.missing_count' | transloco">{{ s.missing_count }}</span>
              </td>
            </ng-container>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</section>
